import React, { ErrorInfo } from "react";

import * as log from "loglevel";

export interface IErrorResistantContentProps {
  layout?: React.ComponentType<any>;
  fallbackComponentFactory?: (details: string) => React.ReactNode;
}

export class ErrorResistantContent extends React.Component<IErrorResistantContentProps> {
  public state = {
    details: "",
    isError: false
  };

  public render() {
    if (this.state.isError) {
      const Layout = this.props.layout || React.Fragment;

      return <Layout>{this.props.fallbackComponentFactory?.(this.state.details)}</Layout>;
    } else {
      return this.props.children;
    }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      details: error.message,
      isError: true
    });

    log.error(error, errorInfo);
  }
}
